import * as Yup from "yup";
import { REQUIRED_FIELD } from "constants/validator-messages";

export const developersConfigApiKeyValidation = Yup.object().shape({
  name: Yup.string().required(REQUIRED_FIELD),
});
